import { environment } from '../environment';

export async function queryStrapi<T extends Record<string, unknown>>(
  query: string,
  variables: Record<string, unknown>
): Promise<T> {
  const queryData = await fetch(environment.STRAPI_GRAPHQL_API_URI, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${environment.STRAPI_API_TOKEN}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query, variables })
  }).then<T>((r) => r.json());

  return queryData;
}
